var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto sds-detail-table mb-5",attrs:{"elevation":"0","data-testid":"sds-detail-table"}},[_c('div',[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }